import { Mapping } from 'api/MappingsAPI';
import { createContext, useContext } from 'react';
import noop from 'utils/noop';

export type PurchaseMappingsContextState = {
  isErrorPurchaseMappings: boolean;
  isLoadingPurchaseMappings: boolean;
  refetchPurchaseMappings: () => void;
  purchaseMappings: Mapping[];
};

export const initialPurchaseMappingsState: PurchaseMappingsContextState = {
  isErrorPurchaseMappings: false,
  isLoadingPurchaseMappings: false,
  refetchPurchaseMappings: noop,
  purchaseMappings: [],
};

export const PurchaseMappingsContext = createContext(initialPurchaseMappingsState);

export const usePurchaseMappingsContext = () => useContext(PurchaseMappingsContext);
